<template>
  <v-app id="main">
    <v-content>
      <v-parallax
        dark
        src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
        v-bind:height="getHeight()"
        v-bind:width="getWidth()"
      >
        <Welcome
          data-aos="fade-up"
          data-aos-duration="3000"
          data-aos-offset="100"
          data-aos-easing="ease-out-back"
        />
        <v-col
          class="text-center"
          data-aos="fade-down"
          data-aos-duration="3000"
          data-aos-offset="100"
          data-aos-easing="ease-out-back"
        >
          <v-btn
            tile
            block
            icon
            @click="$vuetify.goTo(goToPosts, options)"
            v-bind:height="getHeight()/3"
          >
            <v-icon size="50" dark>mdi-chevron-double-down</v-icon>
          </v-btn>
        </v-col>
      </v-parallax>
      <Posts />
    </v-content>
  </v-app>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";

import Welcome from "@/components/Welcome";
import Posts from "@/components/Posts";

export default {
  methods: {
    getHeight() {
      return window.innerHeight;
    },
    getWidth() {
      return window.innerWidth;
    }
  },
  name: "App",
  components: {
    Welcome,
    Posts
  },
  computed: {
    goToPosts() {
      return "#posts";
    },
    options() {
      return {
        duration: 1000,
        offset: 0,
        easing: "easeInOutCubic"
      };
    }
  }
};
AOS.init();
</script>
